/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { HistoryOps } from '../../../core/model/history-ops.model';
import { SelectItem } from 'primeng/api/selectitem';

@Component({
  selector: 'lms-lms-history-header-sub-type',
  templateUrl: './lms-history-header-sub-type.component.html',
  styleUrls: ['./lms-history-header-sub-type.component.scss']
})
export class LmsHistoryHeaderSubTypeComponent implements OnInit {

  daysSpinner: SelectItem[];
  configData: any;

  @Input() historyOps: HistoryOps;
  @Input() tabIndex: number;

  @Output() historyTypeValueChange: EventEmitter<HistoryOps> = new EventEmitter<HistoryOps>();

  /**
   * Creates an instance of LmsHistoryHeaderSubTypeComponent.
   * @param {ConfigService} configService
   * @memberOf LmsHistoryHeaderSubTypeComponent
   */
  constructor(private configService: ConfigService, public appUtilService: AppUtilityService) {
    this.configData = this.configService.getConfigData();
    this.daysSpinner = [];
    this.daysSpinner = this.configData.daySpinner;
  }

  /**
   * this is life cycle method of this component
   * this method will be called on init of this
   * component
   * @memberOf LmsHistoryHeaderSubTypeComponent
   */
  ngOnInit() {
  }

  /**
   * this method is used to handle search enquiry
   * on basis of display type selection
   * @param {string} displayType
   * @memberOf LmsHistoryHeaderSubTypeComponent
   */
  getValueForDisplayType(displayType: string) {
    const ops: HistoryOps = {};
    ops.days = this.historyOps.days;
    ops.displayType = displayType;
    this.historyTypeValueChange.emit(ops);
  }

  /**
   * this method is used to handle the value changes
   * in days spinner. new value will be emitted to parent
   * and so on to get the new data for the current selected
   * set of data
   * @param {any} days
   * @memberOf LmsHistoryHeaderSubTypeComponent
   */
  getValueForDays(days, daysSpinner: any) {
    const ops: HistoryOps = {};
    ops.days = days;
    ops.displayType = this.historyOps.displayType;
    this.appUtilService.removeFilterTextBoxValue();
    if (daysSpinner) {
      daysSpinner.resetFilter();
    }
    this.historyTypeValueChange.emit(ops);
  }

}
